/** @format */

import {LogRecordFromQuery} from '../../types';
import {getLogsCollection} from './getLogsCollection';
import {GroupBreakdown, ScatterCollection, ScatterData} from '../../models/scatters';
import {aggregateScatter} from '../scatter-discreteness/aggregateScatter';

interface Options {
  data: ReadonlyArray<LogRecordFromQuery>;
  daysRange: number;
  rechartsDates: string[];
}

const mapLogs = ({data, daysRange, rechartsDates}: Options): ScatterData => {
  const grouped = getLogsCollection(data);

  const collection: ScatterCollection = {};
  const groupCollection: {[date: string]: GroupBreakdown} = {};

  Object.entries(grouped).forEach(([date, {total, byGroup}]) => {
    collection[date] = total;
    groupCollection[date] = byGroup;
  });

  return aggregateScatter({
    collection,
    groupCollection,
    daysRange,
    rechartsDates,
  });
};

export {mapLogs};
